import { Component, EventEmitter, Output } from '@angular/core';
import { IconNames } from '@app/shared/enums/icon-names';
import { MatDialogClose } from '@angular/material/dialog';
import { IceIconButtonComponent } from '@app/shared/components/atoms/ice-icon-button/ice-icon-button.component';

@Component({
  selector: 'app-equipment-dialog-header',
  templateUrl: './equipment-dialog-header.component.html',
  styleUrl: './equipment-dialog-header.component.scss',
  imports: [IceIconButtonComponent, MatDialogClose],
})
export class EquipmentDialogHeaderComponent {
  IconNames = IconNames;

  @Output() closeDialog = new EventEmitter<void>();
}
